
import layoutMixin from "@/utils/mixins/layoutMixin"
import UserService from "@/services/auth/UserService";
import AuthService from "@/services/authService";
import S3Service from "@/services/integration/S3Service";
import { Money } from "v-money";
import { Component, Vue, Watch } from "vue-property-decorator";


@Component({
  mixins: [
    layoutMixin
  ],

  components: {
    Money
  }
})
export default class MyAccount extends Vue {
  private tabIndex: Number | String = this.$route.params.tabIndex

  private userDataForm = {
    name: "",
    phone: "",
    birth_date: "",
    nickname: "",
    person_email: "",
    email: "",
    monthly_goal: (this.$auth.user().profile == 'operator' ? "0" : undefined)
  }

  private form: any = {
    old_password: "",
    new_password: "",
    password_confirmation: ""
  };

  private error: string = "";
  private validFeedback: string = "";
  private loading: boolean = false;
  private passwordFieldType:string = 'password';
  private oldPasswordFieldType:string = 'password';
  private authServiceInstance = new AuthService();
  private report_metrics_daily:boolean = false;

  private returnError: boolean = false;

  private returnSuccess:boolean = false;

  private moneyMask: any = {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false /* doesn't work with directive */
    }

  private saveSuccessful: boolean = false;
  private saveUnsuccessful: boolean = false;

  private fileAvatar:any = null;

  private trigger: boolean = false;
  private message: string = '';
  private image: any;
  private imageUrl:any;

  private pathAvatarSuffix:string = process.env.NODE_ENV === 'development'
      ? 'development'
      : 'production';

  private user:any = {
        id: this.$auth.user().id_user,
        nickname: this.$auth.user().name,
        avatar: `https://weclever-public.s3.amazonaws.com/dashboard/avatar/${this.pathAvatarSuffix}/${this.$auth.user().id_user}.jpg`,
  }

  @Watch("saveSuccessful")
  onSuccess(value: boolean, oldValue: boolean) {
    if (value === true) {
      setTimeout(() => {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Dados salvos com sucesso.');
      }, 5000);
    }
  }
  @Watch("saveUnsuccessful")
  onError(value: boolean, oldValue: boolean) {
    if (value === true) {
      setTimeout(() => {
        this.$store.commit("navBarAlert/WARNING_ALERT", `Error ao salvar os dados, tente mais tarde novamente.`);
      }, 5000);
    }
  }

  private async created() {
    this.authServiceInstance.getGeneralData(this.$auth.user().id_user, this.$auth.user().id_platform).then((result: any) => {
      if (result && result[0].report_metrics_daily !== undefined) {
        this.report_metrics_daily = !!result.find((e) => e.report_metrics_daily === 0);
      }
    });

    let userService = new UserService();
    try {
      const response = await userService.getUserMyData();

      this.userDataForm = response.body;
      if(this.userDataForm.birth_date)
        this.userDataForm.birth_date = this.$moment(this.userDataForm.birth_date).add(+3, 'hours').format("DD/MM/YYYY");

      if (response.body.goal)
        this.userDataForm.monthly_goal = response.body.goal;

    } catch (error) {
      console.log(error);
    }
  }

  private saveGeneralData() {
    const config = {
      id_user: this.$auth.user().id_user,
      id_platform: this.$auth.user().id_platform,
      report_metrics_daily: !this.report_metrics_daily
    }

    this.loading = true;
    this.authServiceInstance.setGeneralData(config).then((result: any) => {
      this.loading = false;

      if (result && result.indexOf('success') !== -1) {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Dados salvos com sucesso.');
      } else {
        this.$store.commit("navBarAlert/WARNING_ALERT", `Error ao salvar os dados, tente mais tarde novamente.`);
      }
    });
  }

  private showPassword() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  }
  private showOldPassword() {
    this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password'
  }

  private async userMonthlyGoal(evt) {
    evt.preventDefault();
    const userService = new UserService();
    this.loading = true;

    try {
        await userService.setUserMyData(this.userDataForm);
    } catch (error) {
        console.log(error);
        this.$store.commit("navBarAlert/WARNING_ALERT", `Error ao salvar os dados, tente mais tarde novamente.`);
    } finally {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Dados salvos com sucesso.');
        this.loading = false;
    }
  }

  private async userDataFormSubmit(evt: Event) {
    evt.preventDefault();

    const userService = new UserService();

    this.loading = true;

    if(!this.userDataForm.birth_date || this.userDataForm.birth_date.match(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/) === null){
        this.error = 'Data de nascimento inválida';
        this.loading = false;
        return
    }

    if(!this.userDataForm.nickname || this.userDataForm.nickname.split(' ').length < 2 ||
      !this.userDataForm.nickname.split(' ')[0] || !this.userDataForm.nickname.split(' ')[1]){
      this.error = 'Nome muito generico, coloque pelo menos 2 nomes';
      this.loading = false;
      return
    }

    if(!this.userDataForm.person_email ||
        this.userDataForm.person_email.match(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gi) === null ||
        this.userDataForm.person_email.indexOf("weclever") != -1){
      this.error = 'Email inválido';
      this.loading = false;
      return
    }

    const header = {
      headers: {
        'Content-Type': 'image/jpeg'
      }
    }

    const s3Service = new S3Service();

    const avatarData = await s3Service.getUrlUpload({
        path: `dashboard/avatar/${this.pathAvatarSuffix}`,
        bucket: 'weclever-public',
        extension: '.jpg',
        userId: this.$auth.user().id_user
    });

    try {
      if(this.fileAvatar)
        await this.$http.put(avatarData.url, this.fileAvatar, header);

      await userService.setUserMyData(this.userDataForm);
    } catch (error) {
      console.log(error);
      this.$store.commit("navBarAlert/WARNING_ALERT", `Error ao salvar os dados, tente mais tarde novamente.`);
    } finally {
      this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Dados salvos com sucesso.');
      this.loading = false;
    }
  }

  private onChangeAvatar(e) {
    const me = this;
    const reader = new FileReader();
    this.fileAvatar = e.target.files[0];
    reader.readAsDataURL(this.fileAvatar);

    reader.onload = function () {
        me.user.avatar = reader.result;
    };
    reader.onerror = function (error) {
        console.error('Error: ', error);
    };
  }

  private onSubmit(evt: any) {
    evt.preventDefault();
    this.loading = true;

    this.authServiceInstance.change_password(this.form).then((result: any) => {
      this.loading = false;

      if (result == true) {
        this.error = "";
        this.validFeedback = "Senha alterada com sucesso";
        this.form.old_password = "";
        this.form.new_password = "";
        this.form.password_confirmation = "";
      } else if (result == "WRONG_PASSWORD") {
        this.error = "Senha incorreta";
      } else if (result == "NO_MATCHING_PASSWORDS") {
        this.error = "As senhas não coincidem";
      }
    });
  }
}
